import { render, staticRenderFns } from "./RecomendacionesImportacion.vue?vue&type=template&id=720a010e"
import script from "./RecomendacionesImportacion.vue?vue&type=script&lang=js"
export * from "./RecomendacionesImportacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_css-loader@6.11.0_webpack@5.107.2_postcss@8_ff446875d22e2f3af5a28e88f68f10a6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports